import script from "./forgot.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot.vue?vue&type=script&setup=true&lang=js"

import "./forgot.vue?vue&type=style&index=0&id=5571845a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5571845a"]])

export default __exports__